/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

const obfuscateJson = (src: any, options: any) => {
  const obJson =
    typeof src === 'object' ? JSON.parse(JSON.stringify(src)) : JSON.parse(src);
  const newOptions = {
    listWordsObfuscate:
      options.listWordsObfuscate !== undefined
        ? options.listWordsObfuscate
        : [],
  };

  const obfuscate = (obj: any, options: any) => {
    for (const prop in obj) {
      if (typeof obj[prop] === 'object') {
        obfuscate(obj[prop], options);
      } else {
        if (options.listWordsObfuscate.indexOf(prop.toLowerCase()) !== -1) {
          if (typeof obj[prop] === 'number') {
            obj[prop] = Number(obj[prop].toString().replace(/([\d])/g, '1'));
          } else if (typeof obj[prop] === 'string') {
            const canModify = true;

            // if (options.keepStringBits) {
            //   canModify = obj[prop] !== 'true' && obj[prop] !== 'false';
            // }

            if (canModify) {
              obj[prop] = obj[prop].replace(/([a-zA-Z])/g, 'X');
              obj[prop] = obj[prop].replace(/([\d])/g, '1');
            }
          }
        }
      }
    }
  };
  obfuscate(obJson, newOptions);
  return obJson;
};

export default obfuscateJson;
